<template>

    <div class="hero-wrapper">

        <canvas ref="canvas" class="particle-canvas"></canvas>

        <div class="hero-content">

            <img src="@/assets/logo.png" alt="WIESNERD" class="hero-logo" />

            <p class="hero-tagline">IT, Automation und Webentwicklung aus einer Hand.</p>

            <a href="#contact" class="hero-cta" @click.prevent="scrollTo('contact')">
                Kontakt aufnehmen
            </a>

        </div>

    </div>

</template>

<script>

    export default {

        name: 'TheHomeComponent',

        data() {

            return {

                particles: [],
                animationFrame: null,

            }

        },

        mounted() {

            this.$nextTick(() => {

                this.initParticles()
                window.addEventListener('resize', this.handleResize)

            })

        },

        beforeUnmount() {

            window.removeEventListener('resize', this.handleResize)
            cancelAnimationFrame(this.animationFrame)

        },

        methods: {

            initParticles() {

                const canvas = this.$refs.canvas
                const ctx = canvas.getContext('2d')

                canvas.width = window.innerWidth
                canvas.height = window.innerHeight

                const count = Math.min(Math.floor((canvas.width * canvas.height) / 9000), 80)

                this.particles = Array.from({ length: count }, () => ({

                    x: Math.random() * canvas.width,
                    y: Math.random() * canvas.height,
                    vx: (Math.random() - 0.5) * 0.4,
                    vy: (Math.random() - 0.5) * 0.4,
                    radius: Math.random() * 1.5 + 0.5,

                }))

                const animate = () => {

                    ctx.clearRect(0, 0, canvas.width, canvas.height)

                    ctx.lineWidth = 0.6
                    ctx.beginPath()

                    for (let i = 0; i < this.particles.length; i++) {

                        for (let j = i + 1; j < this.particles.length; j++) {

                            const dx = this.particles[i].x - this.particles[j].x
                            const dy = this.particles[i].y - this.particles[j].y
                            const dist = Math.sqrt(dx * dx + dy * dy)

                            if (dist < 160) {

                                ctx.moveTo(this.particles[i].x, this.particles[i].y)
                                ctx.lineTo(this.particles[j].x, this.particles[j].y)

                            }

                        }

                    }

                    ctx.strokeStyle = 'rgba(0, 180, 255, 0.2)'
                    ctx.stroke()

                    for (let i = 0; i < this.particles.length; i++) {

                        ctx.beginPath()
                        ctx.arc(this.particles[i].x, this.particles[i].y, this.particles[i].radius, 0, Math.PI * 2)
                        ctx.fillStyle = 'rgba(0, 180, 255, 0.55)'
                        ctx.fill()

                        this.particles[i].x += this.particles[i].vx
                        this.particles[i].y += this.particles[i].vy

                        if (this.particles[i].x < 0 || this.particles[i].x > canvas.width) {
                            this.particles[i].vx *= -1
                        }

                        if (this.particles[i].y < 0 || this.particles[i].y > canvas.height) {
                            this.particles[i].vy *= -1
                        }

                    }

                    this.animationFrame = requestAnimationFrame(animate)

                }

                animate()

            },

            handleResize() {

                cancelAnimationFrame(this.animationFrame)
                this.initParticles()

            },

            scrollTo(id) {

                const el = document.getElementById(id)
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })

            },

        },

    }

</script>

<style scoped>

    .hero-wrapper {

        position: relative;
        width: 100%;
        height: 100vh;
        background-color: #0d1f3c;
        background-image: radial-gradient(ellipse at 50% 44%, rgba(255, 255, 255, 0.06) 0%, transparent 55%);
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;

    }

    .particle-canvas {

        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

    }

    .hero-content {

        position: relative;
        z-index: 10;
        text-align: center;
        padding: 0 1rem;
        animation: fadeInUp 1.4s ease forwards;

    }

    .hero-logo {

        max-width: 360px;
        width: 75%;
        margin-bottom: 2rem;
        filter: drop-shadow(0 0 20px rgba(0, 180, 255, 0.15));

    }

    .hero-tagline {

        color: #b8cce4;
        font-size: 1.15rem;
        margin-bottom: 2.5rem;
        letter-spacing: 0.03em;

    }

    .hero-cta {

        display: inline-block;
        padding: 0.75rem 2.2rem;
        background: transparent;
        border: 1px solid rgba(0, 180, 255, 0.5);
        color: #00b4ff;
        text-decoration: none;
        letter-spacing: 0.06em;
        font-size: 0.95rem;
        transition: all 0.3s ease;

    }

    .hero-cta:hover {

        background: rgba(0, 180, 255, 0.08);
        border-color: rgba(0, 180, 255, 0.9);
        color: #ffffff;
        box-shadow: 0 0 24px rgba(0, 180, 255, 0.15);

    }

    @keyframes fadeInUp {

        from {
            opacity: 0;
            transform: translateY(28px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }

    }

</style>
